import { DiaryCalendarView } from "./diary-calendar-view";

export class SelectedDateRange {
  View: DiaryCalendarView;
  StartDate: Date;
  SelectedDate: Date;
  EndDate: Date;
}
